import { LocationTypes } from '../../../../constants';
import { LocationType, Status } from './LocationForm.types';

export const legacyLocationTypeOptions: {
  transKey: string;
  value: LocationType;
}[] = [
  {
    transKey: 'location.types.shelter',
    value: LocationTypes.evacShelter,
  },
  {
    transKey: 'location.types.animalShelter',
    value: LocationTypes.animalShelter,
  },
  { transKey: 'location.types.info', value: LocationTypes.info },
  {
    transKey: 'location.types.general',
    value: LocationTypes.general,
  },
  { transKey: 'location.types.food', value: LocationTypes.food },
];

export const locationTypeOptions: {
  transKey: string;
  value: LocationType;
}[] = [
  {
    transKey: 'location.types.firstAid',
    value: LocationTypes.firstAid,
  },
  {
    transKey: 'location.types.shelter',
    value: LocationTypes.shelter,
  },
  {
    transKey: 'location.types.evacShelter',
    value: LocationTypes.evacShelter,
  },
  {
    transKey: 'location.types.temporaryEvacPoint',
    value: LocationTypes.temporaryEvacPoint,
  },
  {
    transKey: 'location.types.maskDistribution',
    value: LocationTypes.maskDistribution,
  },
  {
    transKey: 'location.types.communityDistribution',
    value: LocationTypes.communityDistribution,
  },
  {
    transKey: 'location.types.sandBags',
    value: LocationTypes.sandBags,
  },
  { transKey: 'location.types.water', value: LocationTypes.water },
  { transKey: 'location.types.meals', value: LocationTypes.meals },
  {
    transKey: 'location.types.farmersMarket',
    value: LocationTypes.farmersMarket,
  },
  {
    transKey: 'location.types.foodPantry',
    value: LocationTypes.foodPantry,
  },
  {
    transKey: 'location.types.smallAnimalShelter',
    value: LocationTypes.smallAnimalShelter,
  },
  {
    transKey: 'location.types.largeAnimalShelter',
    value: LocationTypes.largeAnimalShelter,
  },
  { transKey: 'location.types.info', value: LocationTypes.info },
  {
    transKey: 'location.types.general',
    value: LocationTypes.general,
  },
];

export const statusOptions: { transKey: string; value: Status }[] = [
  { transKey: 'common.active', value: 'active' },
  { transKey: 'common.inactive', value: 'inactive' },
];
